import { useCallback, useRef, useState } from 'react';

export const useRejectedDateReset = () => {
  const isRejectedRef = useRef(false);
  const [resetKey, setResetKey] = useState(0);

  const markRejected = useCallback(() => {
    isRejectedRef.current = true;
  }, []);

  const onBlur = useCallback((event) => {
    if (!isRejectedRef.current || event.currentTarget.contains(event.relatedTarget)) return;
    isRejectedRef.current = false;
    setResetKey((key) => key + 1);
  }, []);

  return { resetKey, markRejected, onBlur };
};
